import apiCore from '../../utils/api-core';

// Access Control API (gohire-admin, v3). Backend lands in Phase 4; until then the
// screen uses the mocks in ./featureAccess.js. Swap the mock calls for these.

// Feature registry + bundle catalog (global)
export function getFeatureRegistry() {
    return apiCore.get('/api/v3/features');
}
export function getBundles() {
    return apiCore.get('/api/v3/bundles');
}
export function setBundleFeatures(bundleKey, featureKeys) {
    return apiCore.put(`/api/v3/bundles/${bundleKey}`, { feature_keys: featureKeys });
}

// Company licenses (plan + seats + offered bundles)
export function getCompanyLicenses(companyId) {
    return apiCore.get(`/api/v3/company/${companyId}/licenses`);
}
export function createCompanyLicense(companyId, data) {
    return apiCore.post(`/api/v3/company/${companyId}/licenses`, data);
}
export function updateCompanyLicense(companyId, licenseId, patch) {
    return apiCore.put(`/api/v3/company/${companyId}/licenses/${licenseId}`, patch);
}
export function deleteCompanyLicense(companyId, licenseId) {
    return apiCore.delete(`/api/v3/company/${companyId}/licenses/${licenseId}`);
}

// Per-user access: seat/bundle assignments + allow/deny overrides
export function getUserAccess(companyId, userId) {
    return apiCore.get(`/api/v3/company/${companyId}/users/${userId}/access`);
}
export function setUserAccess(companyId, userId, data) {
    return apiCore.put(`/api/v3/company/${companyId}/users/${userId}/access`, data);
}

// Screen summary (users + seat usage)
export function getAccessSummary(companyId) {
    return apiCore.get(`/api/v3/company/${companyId}/access-summary`);
}
